import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ImpuestoTarifa = {

   // async Get(qs) { return await methods.Get("AtencionAlumno/GetById" + useParamsJson(qs)) },
    async Get() { return await methods.Get("ImpuestoTarifa/Get" ); },
    async Post(data) { return await methods.Post("ImpuestoTarifa/Post", data) },
    async Put(qs, data) { return await methods.Put("ImpuestoTarifa/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ImpuestoTarifa/Delete" + useParamsJson(qs)) }
};

export default ImpuestoTarifa;